/*
 * Currency prefix for ambiguous "$" currencies (USD/CAD/HKD/AUD/SGD/NZD).
 *
 * The JS money formatter already uses the prefixed format (theme.settings.moneyFormat,
 * built in snippets/theme-variables.liquid), so dynamic prices are handled.
 * This script prefixes SERVER-RENDERED (Liquid `| money`) prices in the DOM, which
 * still output a bare "$", and re-applies to prices injected later (cart, quick view).
 *
 * The region code is prepended only to a "$" that begins a price and is not already
 * preceded by a letter, so "US$" never becomes "USUS$".
 */
(function () {
  var prefix = (window.theme && theme.settings && theme.settings.currencyPrefix) || '';
  if (!prefix) return; // base/unambiguous currency — nothing to do

  var TAG = prefix + '$';
  // A "$" that: is at string start or preceded by a non-letter, and is followed by a digit
  // (optionally after a space / non-breaking space). The leading group guards against
  // double-prefixing an already-tagged symbol.
  var PRICE_RE = /(^|[^A-Za-z])\$(?=[\s ]?\d)/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, OPTION: 1 };

  function fixTextNode(node) {
    var parent = node.parentNode;
    if (parent && SKIP[parent.nodeName]) return;
    var value = node.nodeValue;
    if (!value || value.indexOf('$') === -1) return;
    var next = value.replace(PRICE_RE, function (m, pre) { return pre + TAG; });
    if (next !== value) node.nodeValue = next;
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixTextNode(root); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return (n.parentNode && SKIP[n.parentNode.nodeName])
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = walker.nextNode())) fixTextNode(n);
  }

  var observer;
  function observe() {
    if (observer || !window.MutationObserver) return;
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          fixTextNode(m.target);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
        }
      }
    });
    // Setting nodeValue re-fires characterData, but the regex guard makes the second
    // pass a no-op (the "$" is now preceded by a letter), so there is no loop.
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function run() {
    walk(document.body);
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
